import {get} from 'lodash';

export default (state: any, {imageType, url}: any) => ({
  ...state,
  businessProfileImage: {
    ...get(state, 'businessProfileImage', {}),
    [imageType]: {
      ...get(state, `businessProfileImage.${imageType}`, {}),
      url,
    },
  },
});
